'use client';

import { useSyncExternalStore } from 'react';
import { useTheme } from 'next-themes';

const subscribe = () => () => {};

/** `theme` is undefined until mounted, so server and first client render match. */
export default function useShaojiangTheme() {
  const mounted = useSyncExternalStore(
    subscribe,
    () => true,
    () => false,
  );
  const { theme, setTheme, resolvedTheme } = useTheme();

  return { theme: mounted ? (resolvedTheme ?? theme) : undefined, setTheme };
}
